import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
    selector: 'kh-dropdown-menu',
    templateUrl: './dropdown-menu.component.html',
    styleUrls: ['./dropdown-menu.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DropdownMenuComponent {
  @Input() label?: string;
  @Input() alignmentRight = false;
}
